import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { trackSignupSuccess } from '@/lib/analytics';

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionMatch = hash.match(/session_id=([^&]+)/);
        
        // Determine intended role from path first (needed for error redirects)
        const currentPath = window.location.pathname;
        let intendedRole = 'superadmin'; // default
        if (currentPath.includes('/admin')) {
          intendedRole = 'admin';
        } else if (currentPath.includes('/superadmin') || currentPath.includes('/guru')) {
          intendedRole = 'superadmin';
        }
        
        // Error redirect helper based on role
        const errorRedirect = intendedRole === 'admin' ? '/admin' 
                            : intendedRole === 'staff' ? '/login' 
                            : '/guru';
        
        if (!sessionMatch) {
          console.error('No session_id found in URL');
          navigate(errorRedirect);
          return;
        }
        
        const sessionId = sessionMatch[1];
        
        // Exchange session_id for user data and session_token
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const response = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: {
              'X-Session-ID': sessionId,
              'X-Intended-Role': intendedRole
            },
            withCredentials: true
          }
        );
        
        const userData = response.data;

        // Brand-new admin account created via OAuth session exchange
        if (userData.is_new_user === true && userData.role === 'admin') {
          trackSignupSuccess('google');
        }
        
        // Navigate based on role
        if (userData.role === 'superadmin') {
          navigate('/superadmin/dashboard', { state: { user: userData } });
        } else if (userData.role === 'admin') {
          navigate('/admin/dashboard', { state: { user: userData } });
        } else if (userData.role === 'staff') {
          navigate('/dashboard', { state: { user: userData } });
        } else {
          navigate('/guru');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        // Redirect to appropriate login page based on intended destination
        const currentPath = window.location.pathname;
        if (currentPath.includes('/admin')) {
          navigate('/admin');
        } else if (currentPath.includes('/superadmin') || currentPath.includes('/guru')) {
          navigate('/guru');
        } else {
          navigate('/login');
        }
      }
    };
    
    processSession();
  }, [location, navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Authenticating...</p>
      </div>
    </div>
  );
}

export default AuthCallback;